import { empty } from "@apollo/client";
import { defineStyle } from "@chakra-ui/react";

export const TutorReviewModeStyles = (
  isReviewRoute = false,
  emptyState = false
) => {
  return {
    mainContainer: defineStyle({
      display: "flex",
      flexDirection: "column",
      justifyContent: emptyState && "center",
      alignItems: emptyState && "center",
      bg: "#F5F4FA",
      height: isReviewRoute ? "calc(100vh - 80px)" : "",
    }),
    reviewPresenterContainer: defineStyle({
      width: "100%",
      pb: "150px",
      overflowY: "auto",
      paddingX: { base: "24px", md: "0" },
    }),
    editorBox: defineStyle({
      position: "fixed",
      left: "0",
      bottom: "0",
      width: { base: "100%", lg: "104%" },
      bg: "linear-gradient(139.61deg, rgba(255, 255, 255, 0.3) 4.47%, rgba(255, 255, 255, 0) 98.47%);",
      backdropFilter: "blur(40px)",
    }),
    emptyJourneyContainer: defineStyle({
      width: "100%",
      paddingTop: "36px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "16px",
      bg: "linear-gradient(139.61deg, rgba(255, 255, 255, 0.3) 4.47%, rgba(255, 255, 255, 0) 98.47%);",
      backdropFilter: "blur(40px)",
    }),
    emptyJourneyContainerTitle: defineStyle({
      fontFamily: "Poppins",
      fontWeight: "600",
      fontSize: "20px",
      paddingTop: "16px",
      color: "#5F4DC7",
      textAlign: "center",
    }),
    emptyJourneyContainerDescription: defineStyle({
      fontFamily: "Poppins",
      fontWeight: "400",
      fontSize: "18px",
      color: "#353535",
      paddingTop: "5px",
      marginBottom: "36px",
      textAlign: "center",
    }),
  };
};
